const isReportTab = (
  tab: EntityDetails.ClientTab,
): tab is EntityDetails.ReportTab => tab.type === 'report';

const isDashboardTab = (
  tab: EntityDetails.ClientTab,
): tab is EntityDetails.DashboardTab => tab.type === 'dashboard';

const isBoardTab = (
  tab: EntityDetails.ClientTab,
): tab is EntityDetails.BoardTab => tab.type === 'board';

const isDriverBonusProgramReportTab = (
  tab: EntityDetails.ClientTab,
): tab is EntityDetails.DriverBonusProgramReportTab =>
  tab.type === 'driver-bonus-program-report';

const isDriverBonusCombinedTab = (
  tab: EntityDetails.ClientTab,
): tab is EntityDetails.DriverBonusCombinedTab =>
  tab.type === 'driver-bonus-combined';

const isDriverDetailsTab = (
  tab: EntityDetails.ClientTab,
): tab is EntityDetails.DriverDetailsTab => tab.type === 'driver-details-tab';

const isScorecardTab = (
  tab: EntityDetails.ClientTab,
): tab is EntityDetails.ScorecardTab => tab.type === 'scorecard';

const entityDetailsClientTabTypeCheckers = {
  isReportTab,
  isDashboardTab,
  isBoardTab,
  isDriverBonusProgramReportTab,
  isDriverBonusCombinedTab,
  isDriverDetailsTab,
  isScorecardTab,
};

export default entityDetailsClientTabTypeCheckers;
